import { memo, useState } from 'react';
import classNames from 'classnames';
import { t } from 'ttag';

import FeedFilterTitle from '@components/FeedFilterTitle';
import { ColorEnum } from '@models';
import { Button } from '@ui/Button';
import {
  useIndexedFilters,
} from '@hook/productFilters';

import s from './FeedColorFilter.sss';

// types
export type ColorOptions = {
  id: string;
  name: string;
  hex?: string | null;
  enum: ColorEnum
  isIndexed: boolean
};

type FeedColorFilterProps = {
  options: ColorOptions[];
  actives: number[];
  isMobile: boolean;
  onChange(option: ColorOptions): void;
};

export const FeedColorFilter: React.FC<FeedColorFilterProps> = memo(({
  options,
  actives,
  onChange,
  isMobile,
}) => {
  const [isHide, setHide] = useState(false);
  const activeColors = actives || [];
  const { generateIndexedFilterPath } = useIndexedFilters();

  return (
    <div className={classNames([s.root, { [s.mobile]: isMobile }])}>
      <FeedFilterTitle
        title={t`Колір`}
        hide={isHide}
        onClick={() => setHide(!isHide)}
      />
      { !isHide && (
        <ul className={s.colorList}>
          {options.map((data) => (
            <li
              key={data.id}
              className={s.item}
              title={data.name}
            >
              <Button
                className={classNames(
                  s.color,
                  { [s.white]: data.enum === ColorEnum.White },
                  { [s.diff]: data.enum === ColorEnum.Multicolor },
                  { [s.active]: activeColors.includes(+data.id) },
                )}
                theme="text"
                {...(data.isIndexed && {
                  to: generateIndexedFilterPath({ colors: [+data.id] }),
                })}
                onClick={(e) => {
                  e.preventDefault();
        
                  onChange(data);
                }}
                style={{ background: `#${data.hex}` }}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
});

FeedColorFilter.displayName = 'FeedColorFilter';
